import { Fragment, ReactNode } from 'react';

export function textToHtml(text: string): ReactNode {
  return text.split('\n').map((t, i) =>
    i > 0 ? (
      <Fragment key={i.toString()}>
        <br />
        {t}
      </Fragment>
    ) : (
      <Fragment key={i.toString()}>{t}</Fragment>
    )
  );
}
